import React from "react";

const HeadingTwoStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.75 2.75H3.25M3.25 2.75H4.25M3.25 2.75V9.75M3.25 9.75V17.25M3.25 9.75H11.75M3.25 17.25H1.75M3.25 17.25H4.25M11.75 9.75V2.75M11.75 9.75V17.25M11.75 2.75H13.25M11.75 2.75H10.75M11.75 17.25H13.25M11.75 17.25H10.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 14.5H15.9062C15.1755 14.5 14.7682 13.6859 15.1558 13.1074C15.2035 13.0361 15.2711 12.9811 15.3425 12.9336L17.1424 11.736C17.2138 11.6884 17.2812 11.6332 17.3299 11.5626C17.7753 10.9178 17.3213 10 16.5026 10H15",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(HeadingTwoStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;